import { linearGradientDef } from '@nivo/core';

import { IStrategy, IStrategyAsset } from '../../../types/model';

export function gatherAllStrategyAssets(
  strategies: IStrategy[]
): IStrategyAsset[] {
  return strategies.reduce<IStrategyAsset[]>(
    (prev, strategy) => prev.concat(strategy.strategyAssets.items),
    []
  );
}

export interface IAllAssetsCombined {
  name: string;
  value: number;
  percentage: number;
  hasPrice: boolean;
  withPercentage: boolean;
}

/* CHART */
export const COLORS = {
  veryLight: '#C780FF', // very good
  light: '#B557FF',
  normal: '#A32EFF',
  medium: '#9105FF',
  dark: '#7B00DB',
  veryDark: '#6400B2', // very bad
};

export function getColor({ percentage }: { percentage: number }) {
  if (percentage > 80) return COLORS['veryLight'];
  if (percentage > 40) return COLORS['light'];
  if (percentage > 20) return COLORS['normal'];
  if (percentage > 0) return COLORS['medium'];

  if (percentage < -80) return COLORS['veryDark'];
  if (percentage < -40) return COLORS['dark'];
  if (percentage < -20) return COLORS['medium'];
  if (percentage < 0) return COLORS['normal'];
  return COLORS['normal'];
}

export function gradient(label: string, color1: string, color2: string) {
  return linearGradientDef(
    label,
    [
      { offset: 0, color: color1 },
      { offset: 100, color: color2 },
    ],
    {
      gradientTransform: 'scale(1.05) skew(30deg,20deg)',
    }
  );
}
